












import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
@Component
export default class HelloWorld extends myVue {
    querySearch(queryString:any, cb:any) {
        let options = this.current.options;
        let results = queryString ? options.filter(this.createFilter(queryString)) : options;
        cb(results);
    }
    createFilter(queryString:any) {
        return (restaurant:any) => {
            return (restaurant[this.current.props_value].toLowerCase().indexOf(queryString.toLowerCase()) != -1);
        };
    }
}
